import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Image from 'next/image';
import * as React from 'react';
import { Images } from '../assets';

interface ErrorContainerProps {
  errorMessage: string;
  handleRetry: () => void;
}

const ErrorContainer = ({ errorMessage, handleRetry }: ErrorContainerProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        padding: '40px'
      }}
    >
      <Typography align="center">
        <Image src={Images.ERROR} width={80} height={80} alt="error" />
      </Typography>
      <Typography
        component="h4"
        align="center"
        sx={{
          fontFamily: theme?.MojitoClaim?.font?.primary,
          fontWeight: 500,
          fontSize: '24px',
          padding: '24px 0 16px 0'
        }}
      >
        Something went wrong...
      </Typography>
      <Typography
        sx={{
          marginBottom: '15px',
          fontFamily: theme?.MojitoClaim?.font?.secondary
        }}
        align="center"
      >
        {errorMessage}
      </Typography>
      <Button
        sx={{
          width: '100%'
        }}
        onClick={handleRetry}
      >
        Retry
      </Button>
    </Box>
  );
};

export default ErrorContainer;
